module.exports = __webpack_public_path__ + "img/b4a64b9.jpg";